import styled from 'styled-components';
import Button from '../Button';
import Icon from '../Icon';

export const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row nowrap;
  margin: 0 0 18px 0;
  padding: 0;
`;

export const StyledTitle = styled.h2`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const StyledActions = styled.div`
  margin-top: 36px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  button {
    letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  }
`;

export const StyledPrimaryButton = styled(Button.Primary)`
  min-width: 125px;
  height: 36px;
  margin-left: 18px;
`;

export const StyledIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  margin-right: 10px;
  vertical-align: middle;
`;

export const ConfirmationMsg = styled.div``;

export default {
  StyledTitle,
  StyledActions,
  StyledPrimaryButton
};
